import React from 'react';
import { cn } from '../lib/cn';

/**
 * Card — Tarjeta con borde sutil (sin sombra) y radius xl.
 *
 * Anatomía:
 *   <Card>
 *     <CardHeader>
 *       <CardTitle>Título</CardTitle>
 *       <CardDescription>Texto descriptivo</CardDescription>
 *     </CardHeader>
 *     <CardContent>...</CardContent>
 *     <CardFooter>...</CardFooter>
 *   </Card>
 */
export const Card = React.forwardRef(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn(
            'rounded-xl border border-[hsl(var(--border))] bg-white',
            className
        )}
        {...props}
    />
));
Card.displayName = 'Card';

export const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn('flex flex-col gap-1 p-5 pb-3', className)}
        {...props}
    />
));
CardHeader.displayName = 'CardHeader';

export const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
    <h3
        ref={ref}
        className={cn('text-sm font-semibold text-slate-900 leading-tight', className)}
        {...props}
    />
));
CardTitle.displayName = 'CardTitle';

export const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
    <p
        ref={ref}
        className={cn('text-xs text-slate-500', className)}
        {...props}
    />
));
CardDescription.displayName = 'CardDescription';

export const CardContent = React.forwardRef(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn('p-5 pt-0', className)}
        {...props}
    />
));
CardContent.displayName = 'CardContent';

export const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn('flex items-center p-5 pt-3 border-t border-[hsl(var(--border))]', className)}
        {...props}
    />
));
CardFooter.displayName = 'CardFooter';
